module.exports = __webpack_public_path__ + "static/img/a5.b157844.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/index1/hot/a5.png
// module id = pDnU
// module chunks = 0